__turbopack_context__.v({
  "eyebrow": "BlockInlineList-module-scss-module__dGMYQG__eyebrow",
  "flushBottom": "BlockInlineList-module-scss-module__dGMYQG__flushBottom",
  "flushTop": "BlockInlineList-module-scss-module__dGMYQG__flushTop",
  "gridContent": "BlockInlineList-module-scss-module__dGMYQG__gridContent",
  "lastBlock": "BlockInlineList-module-scss-module__dGMYQG__lastBlock",
  "miniGrid": "BlockInlineList-module-scss-module__dGMYQG__miniGrid",
  "root": "BlockInlineList-module-scss-module__dGMYQG__root",
});
